import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const ProjectedFundingGapsBySectorTable = props => (
  <PivotTable
    titles={[
      {
        title: "",
        columnSpan: 1
      },
      {
        title: "Total",
        columnSpan: 3,
        groupStart: true
      },
      {
        title: "Public",
        columnSpan: 3,
        groupStart: true
      },
      {
        title: "Private",
        columnSpan: 3,
        groupStart: true
      }
    ]}
    columnKey="indicator"
    columnDefinitions={[
      {
        value: "Spend (Total)",
        label: "Spending",
        groupStart: true
      },
      {
        value: "Cost Share (Total)",
        label: "Cost Share"
      },
      {
        value: "Gap (Total)",
        label: "Gap"
      },
      {
        value: "Spend (Public)",
        label: "Spending",
        groupStart: true
      },
      {
        value: "Cost Share (Public)",
        label: "Cost Share"
      },
      {
        value: "Gap (Public)",
        label: "Gap"
      },
      {
        value: "Spend (Private)",
        label: "Spending",
        groupStart: true
      },
      {
        value: "Cost Share (Private)",
        label: "Cost Share"
      },
      {
        value: "Gap (Private)",
        label: "Gap"
      }
    ]}
    rowKey="year"
    rowDefinitions={[
      {
        value: "Current",
        current: true
      },
      {
        value: "2020"
      },
      {
        value: "2025"
      },
      {
        value: "Change (#)"
      },
      {
        value: "Change (%)",
        percentage: true
      },
      {
        value: "Cumulative (5 yr)"
      }
    ]}
    data={props.data}
    na="&#8212;"
  />
);

ProjectedFundingGapsBySectorTable.propTypes = {
  data: PropTypes.array.isRequired,
  areaId: PropTypes.number.isRequired
};

export default memo(ProjectedFundingGapsBySectorTable);
